// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__sqb2Y","select":"Header_select__mYqZe","clinic":"Header_clinic__3YJw0"};